var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarketplace(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "marketplace_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 150"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".marketplace_svg__cls-1{fill:none}.marketplace_svg__cls-1,.marketplace_svg__cls-3,.marketplace_svg__cls-5,.marketplace_svg__cls-6{stroke:#0e5b7c;stroke-linecap:round;stroke-linejoin:round}.marketplace_svg__cls-3{fill:#c4c4c4}.marketplace_svg__cls-5{fill:#6e9db0}.marketplace_svg__cls-6{fill:#f8f8f8}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "marketplace_svg__cls-1",
    d: "M140.84 124.45h-54.2V51.77l27.1-26.22 27.1 26.22v72.68z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.92 79.43a15 15 0 017.69 2.13 15.07 15.07 0 0129.14.44 15 15 0 0116 1.93 15.06 15.06 0 0127-1.16 15.07 15.07 0 11-5.31 20.11A15 15 0 0189 101.75a15.06 15.06 0 01-28.39-2.51 15.05 15.05 0 01-6.47 1.47 14.9 14.9 0 01-7.69-2.13 15.08 15.08 0 11-14.53-19.15z",
    fill: "#0e5b7c",
    stroke: "#0e5b7c",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "marketplace_svg__cls-1",
    d: "M9.16 51.83v72.62h131.68V51.83"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "marketplace_svg__cls-3",
    d: "M55.82 51.77c0 6.08 3.45 11 7.71 11s7.7-4.91 7.7-11zM40.41 51.77c0 6.08 3.45 11 7.7 11s7.71-4.91 7.71-11z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "marketplace_svg__cls-3",
    d: "M25 51.77c0 6.08 3.44 11 7.7 11s7.71-4.91 7.71-11zM9.58 51.77c0 6.08 3.45 11 7.7 11s7.72-4.92 7.72-11zM56.13 51.77h15.24l27.1-26.22H83.23l-27.1 26.22z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "marketplace_svg__cls-3",
    d: "M40.89 51.77h15.24l27.1-26.22H67.98L40.89 51.77z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "marketplace_svg__cls-3",
    d: "M24.8 51.77h16.09l27.09-26.22H51.89L24.8 51.77z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "marketplace_svg__cls-3",
    d: "M9.16 51.77H24.8l27.09-26.22H36.37L9.16 51.77z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbc282",
    stroke: "#0e5b7c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M140.84 90.77v33.68H9.16V90.77h131.68z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "marketplace_svg__cls-1",
    d: "M9.16 101.18h131.68M9.16 114.04h131.68M63.36 124.45H9.16V51.77l27.1-26.22 27.1 26.22v72.68z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "marketplace_svg__cls-5",
    d: "M78.77 51.77c0 6.08-3.45 11-7.71 11s-7.7-4.91-7.7-11z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "marketplace_svg__cls-6",
    d: "M94.18 51.77c0 6.08-3.45 11-7.71 11s-7.7-4.91-7.7-11z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "marketplace_svg__cls-5",
    d: "M109.59 51.77c0 6.08-3.45 11-7.7 11s-7.71-4.91-7.71-11z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "marketplace_svg__cls-6",
    d: "M125 51.77c0 6.08-3.44 11-7.7 11s-7.71-4.91-7.71-11z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "marketplace_svg__cls-5",
    d: "M140.42 51.77c0 6.08-3.45 11-7.7 11s-7.72-4.91-7.72-11zM78.63 51.77H63.36l-27.1-26.22h15.27l27.1 26.22z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "marketplace_svg__cls-6",
    d: "M93.87 51.77H78.63l-27.1-26.22h15.24l27.1 26.22z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "marketplace_svg__cls-5",
    d: "M109.11 51.77H93.87l-27.1-26.22h15.25l27.09 26.22z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "marketplace_svg__cls-6",
    d: "M125.2 51.77h-16.09L82.02 25.55h16.09l27.09 26.22z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "marketplace_svg__cls-5",
    d: "M140.84 51.77H125.2L98.11 25.55h15.52l27.21 26.22z"
  })));
}
export default SvgMarketplace;